<div class="flex flex-col justify-between">
  <h3>Publish {{ site.name }}</h3>

  <p class="font-bold text-night">Are you sure you want to publish {{ site.name }}?</p>

  <div class="flex justify-end items-center gap-2 mt-4">
    <sbnb-button type="secondary" (clicked)="dialogRef.close()">Cancel</sbnb-button>

    <sbnb-button type="primary" [loading]="publishing" (clicked)="publish()">Publish</sbnb-button>
  </div>
</div>
